export default __webpack_public_path__ + "static/media/image01.3db9a46f.jpg";